import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { IonAlert, setupIonicReact } from "@ionic/react";

import "../../styles/config.css";

setupIonicReact({ mode: "md" });

type Props = {
  onLogout: () => void;
  onDeleteAccount: (password: string) => void;
  onChangePasswordRequested: () => void;
};

export default function ConfigurationPage({
  onLogout,
  onDeleteAccount,
  onChangePasswordRequested,
}: Props) {
  const [showLogout, setShowLogout] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const MenuItem = ({ title, onClick }: { title: string; onClick: () => void }) => (
    <div className="config-item" onClick={onClick}>
      <span>{title}</span>
      <ChevronRight size={20} />
    </div>
  );

  return (
    <div className="config-page">
      <h2 className="config-title">Configuracion</h2>

      <div className="config-menu">
        <MenuItem title="Cerrar sesion" onClick={() => setShowLogout(true)} />
        <MenuItem title="Eliminar cuenta" onClick={() => setShowDelete(true)} />
        <MenuItem title="Cambiar contrasena" onClick={onChangePasswordRequested} />
      </div>

      <IonAlert
        mode="md"
        isOpen={showLogout}
        header="Cerrar sesion"
        message="Estas seguro de que quieres cerrar la sesion?"
        buttons={[
          { text: "No", role: "cancel", handler: () => setShowLogout(false) },
          { text: "Si", role: "destructive", handler: onLogout },
        ]}
        onDidDismiss={() => setShowLogout(false)}
      />

      <IonAlert
        mode="md"
        isOpen={showDelete}
        header="Eliminar cuenta"
        message="Introduce tu contrasena para confirmar:"
        inputs={[
          {
            name: "password",
            type: "password",
            placeholder: "Contrasena",
          },
        ]}
        buttons={[
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => setShowDelete(false),
          },
          {
            text: "Eliminar",
            role: "destructive",
            handler: (data) => {
              const password = data.password;
              if (password && password.trim() !== "") {
                onDeleteAccount(password);
                return true;
              }

              console.warn("No se introdujo contrasena");
              return false;
            },
          },
        ]}
        onDidDismiss={() => setShowDelete(false)}
      />
    </div>
  );
}
